
import { Vue, Component } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import DeadlineDialog from '../ordermanage/detail/detail/deadline.vue'
import DictSelect from '@/components/busi/custom/dictselect.vue'
import util from '@/utils/busi/util'
import { checkPermission } from '@/utils/permission'
import dayjs from 'dayjs'
import { getOrderList, getOrderListCount, getSignupDeatil } from '@/api/ordercenter'
import { queryCriteriaGradeBySchoolId, schoolSubjectComboBox } from '@/api/common/common'
import { LocalStorage } from '@/utils/storage'
@Component({
  name: 'order-manage',
  components: {
    SimpleTable,
    DeadlineDialog,
    DictSelect
  }
})
export default class OrderManage extends Vue {
  private gradeData = []

  private subjectData = []

  private pickerOptions = {
    shortcuts: [
      {
        text: '上一周',
        onClick (picker: { $emit: (arg0: string, arg1: Date[]) => void }) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
          picker.$emit('pick', [start, end])
        }
      },
      {
        text: '最近一个月',
        onClick (picker: { $emit: (arg0: string, arg1: Date[]) => void }) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
          picker.$emit('pick', [start, end])
        }
      },
      {
        text: '最近三个月',
        onClick (picker: { $emit: (arg0: string, arg1: Date[]) => void }) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
          picker.$emit('pick', [start, end])
        }
      }
    ],
    disabledDate: !0,
    firstDayOfWeek: 7,
    cellClassName: () => 'custClass',
    onPick: null
  }

  get exportName () {
    const day = dayjs(new Date()).format('YYYYMMDD')
    return `订单中心信息-${day}`
  }

  private exportParam () {
    const temp = { ...this.form }
    if (temp.createTime) {
      temp.startTime = temp.createTime[0]
      temp.endTime = temp.createTime[1]
    }
    delete temp.custom_createTime
    return util.trimForm({ ...temp }, this.columns)
  }

  private form: any = {
    createTime: [new Date((new Date()).getFullYear().valueOf() + '/' + '01' + '/' + '01 00:00').getTime(), new Date(new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getDate() + ' 23:59:59').getTime()],
    stuSchoolId: '',
    stuGradeId: '',
    stuSubjectId: '',
    orderState: -1
  }

  private loading = !1

  private exportable = {
    exportable: checkPermission(['orderExport']),
    src: '/lb/order/export',
    data: this.exportParam
  }

  private tableData = {
    list: [],
    totalCount: 1
  }

  private columns = [{
    prop: 'orderNo',
    label: '报读编号',
    disabled: !0
  },
  {
    prop: 'stuName',
    label: '学生姓名'
  },
  {
    prop: 'stuPhone',
    label: '联系电话'
  },
  {
    prop: 'stuPaperworkNumberSix',
    label: '证件后六位'
  },
  {
    prop: 'orderStateName',
    label: '订单状态',
    default: ['orderState']
  },
  {
    prop: 'stuSchoolRollStatus',
    label: '学籍状态',
    disabled: !0
  },
  {
    prop: 'stuBussineName',
    label: '业务名称',
    disabled: !0
  },
  {
    prop: 'studyName',
    label: '学习类型',
    disabled: !0
  },
  {
    prop: 'stuSchoolName',
    label: '报读院校',
    default: ['stuSchoolId']
  },
  {
    prop: 'stuGradeName',
    label: '报读年级',
    default: ['stuGradeId']
  },
  {
    prop: 'stuSubjectName',
    label: '报读专业',
    default: ['stuSubjectId']
  },
  {
    prop: 'money',
    label: '订单金额',
    disabled: !0
  },
  {
    prop: 'createTime',
    label: '报名时间',
    default: ['startTime', 'endTime'],
    format: 'date'
  },
  {
    prop: 'payDeadlineName',
    label: '支付截止时间'
  },
  {
    prop: 'userName',
    label: '上级代理人'
  }]

  private pagination: any = {
    currentPage: 1,
    pageSize: 10
  }

  private async onQuery (pagination: any = null) {
    this.loading = !0
    const temp = { ...this.form }
    if (temp.createTime) {
      temp.startTime = temp.createTime[0]
      temp.endTime = temp.createTime[1]
    }
    delete temp.createTime
    const form = util.trimForm({ ...temp }, this.columns)
    !pagination && (this.pagination.currentPage = 1)
    await getOrderList({
      ...form,
      ...pagination || this.pagination
    }).then(async (res: any) => {
      await getOrderListCount({
        ...form
      }).then((resCount: any) => {
        this.loading = !1
        const userType = LocalStorage.getObj('user_info_key').userType
        if (userType === 3) {
          this.tableData.list = res.object.list.map((v: any) => {
            v.stuPhone && (v.stuPhone = (v.stuPhone.substring(0, 5) + '******'))
            // orderState 1-待支付/2-已支付/3-交易关闭/4-已退款
            return v
          })
        } else {
          this.tableData.list = res.object.list
        }
        this.tableData.totalCount = resCount.object.count
      }).catch((err: any) => {
        console.log('err', err)
        this.loading = !1
      })
    }).catch((err: any) => {
      console.log('err', err)
      this.loading = !1
    })
  }

  private onReset () {
    this.form = {
      createTime: [new Date((new Date()).getFullYear().valueOf() + '/' + '01' + '/' + '01 00:00').getTime(), new Date(new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getDate() + ' 23:59:59').getTime()],
      stuSchoolId: '',
      stuGradeId: '',
      stuSubjectId: '',
      orderState: -1
    }
    this.onQuery()
  }

  private visible = !1

  private detailData = {}

  private setPayDeadline (row: any) {
    this.visible = !0
    this.detailData = row
  }

  private rowDbClick (row: any) {
    this.showDetail('view', row)
  }

  private async showDetail (flag: any, row: any) {
    const userType = LocalStorage.getObj('user_info_key').userType
    const params: any = {
      flag: flag,
      orderNo: row.orderNo,
      crmOrderNo: row.crmOrderNo,
      orderState: row.orderState,
      orderStateName: row.orderStateName,
      signupId: row.signupId
    }
    await getSignupDeatil({
      signupId: row.signupId
    }).then((res: any) => {
      if (res.code === 10000) {
        if (userType === 3) {
          const signup = res.object.signup
          params.stuPhone = signup.stuPhone ? signup.stuPhone.substring(0, 5) + '******' : signup.stuPhone
          params.stuPhoneSpare = signup.stuPhoneSpare ? signup.stuPhoneSpare.substring(0, 5) + '******' : signup.stuPhoneSpare
          params.stuPaperworkNumber = signup.stuPaperworkNumber ? signup.stuPaperworkNumber.substring(0, 5) + '******' : signup.stuPaperworkNumber
          if (signup.stuPaperworkNumber && signup.stuPaperworkNumber.length > 10) {
            params.stuPaperworkNumber += signup.stuPaperworkNumber.slice(-4)
          }
        }
        this.$router.push({
          name: 'orderdetail',
          params: { ...res.object.signup, ...params }
        })
      }
    })
  }

  private async change (val: any) {
    this.form.stuGradeId = ''
    this.form.stuSubjectId = ''
    await queryCriteriaGradeBySchoolId({
      schoolId: val || -999
    }).then((res: any) => {
      if (res.code === 10000) {
        this.gradeData = res.object.list
      }
    })

    await schoolSubjectComboBox({
      schoolId: val || -999
    }).then((res: any) => {
      if (res.code === 10000) {
        this.subjectData = res.object.list
      }
    })
  }

  mounted () {
    this.onQuery()
  }
}
